<template>
  <v-card>
    <v-card-text class="px-0 py-0">
      <v-tabs fixed-tabs v-model="tab">
        <v-tab key="calendar">
          <slot name="dateIcon">
            <v-icon>event</v-icon>
          </slot>
        </v-tab>
        <v-tab key="timer">
          <slot name="timeIcon">
            <v-icon>access_time</v-icon>
          </slot>
        </v-tab>
        <v-tab-item key="calendar">
          <!-- min/max are based on the approximate signed 32-bit unit epoch range -->
          <v-date-picker
            v-model="curDate"
            show-current
            no-title
            scrollable
            color="primary"
            locale="pt-br"
            @change="tab++"
            min="1971-01-01"
            max="2037-01-01"
          ></v-date-picker>
        </v-tab-item>
        <v-tab-item key="timer">
          <v-time-picker
            v-model="curTime"
            format="24hr"
            scrollable
            use-seconds
            color="primary"
            locale="pt-br"
          ></v-time-picker>
        </v-tab-item>
      </v-tabs>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'MyDatetimePicker',
  props: { datetime: String },
  data() {
    return {
      tab: 0,
      curDate: null,
      curTime: null,
    };
  },
  created() {
    this.updateLocalTimes();
  },
  watch: {
    datetime() {
      this.updateLocalTimes();
    },
    curTime() {
      this.changeDatetime();
    },
    curDate() {
      this.changeDatetime();
    },
  },
  methods: {
    updateLocalTimes() {
      this.curDate = this.datetime.split(' - ')[0];
      this.curTime = this.datetime ? this.datetime.split(' - ')[1] : '00:00:00';
    },
    changeDatetime() {
      if (this.curTime && this.curDate) {
        this.$emit('change', `${this.curDate} - ${this.curTime}`);
      } else {
        this.$emit('change', '');
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
